<template>
  <div class="line-2-vertical"></div>
</template>

<script>
export default {
  name: "loadingBot",
};
</script>

<style>
.line-2-vertical {
  --size: 24px;
  --stroke-width: calc(var(--size) / 6);
  --color: rgb(167, 165, 165);
  --animation-timing-function: linear;
  --animation-duration: 1s;
  position: relative;
  width: var(--size);
  height: var(--size);
}

.line-2-vertical::before,
.line-2-vertical::after {
  content: "";
  position: absolute;
  transform: scaleY(1);
  animation: var(--animation-timing-function) var(--animation-duration) infinite
    line-2-vertical-animation;
}

.line-2-vertical::before {
  inset: 0;
  border-right: var(--stroke-width) solid var(--color);
  border-left: var(--stroke-width) solid var(--color);
}

.line-2-vertical::after {
  top: 0;
  bottom: 0;
  left: calc(50% - var(--stroke-width) / 2);
  border-left: var(--stroke-width) solid var(--color);
  animation-delay: calc(var(--animation-duration) / 2);
}

@keyframes line-2-vertical-animation {
  0% {
    transform: scaleY(1);
  }

  50% {
    transform: scaleY(0.5);
  }

  100% {
    transform: scaleY(1);
  }
}
</style>
